// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1n-wm","header":"ClearentDisclaimer_header__2V7pt","inner":"ClearentDisclaimer_inner__KXNbp"};